import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal, Eyebrow, SectionTitle } from "./shared";
import { useSite } from "../../context/SiteContext";

export default function FAQ() {
  const { content } = useSite();
  const faq = content?.faq || [];
  if (!faq.length) return null;

  return (
    <section id="faq" className="py-20 lg:py-28 bg-cream" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="text-center">
            <Eyebrow>Dúvidas comuns</Eyebrow>
            <SectionTitle>Perguntas frequentes</SectionTitle>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <Accordion type="single" collapsible className="mt-12 space-y-3" data-testid="faq-accordion">
            {faq.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="bg-warmwhite border border-gold/20 rounded-2xl px-6 data-[state=open]:border-gold/50 transition-colors"
              >
                <AccordionTrigger
                  data-testid={`faq-question-${i}`}
                  className="text-left font-serif text-lg text-ink hover:text-golddark hover:no-underline py-5"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm sm:text-base font-light text-cocoa leading-relaxed pb-5" data-testid={`faq-answer-${i}`}>
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
